export enum StateEnum {
  PAUSE = 'PAUSE',
  WHITEBOARD = 'WHITEBOARD',
  DRAWING = 'DRAWING',
  RECORD = 'RECORD',
  SEND_VIDEO = 'SEND_VIDEO',
  SHARE_SCREEN = 'SHARE_SCREEN',
  LASER = 'LASER',
  PRIVATE_TALK = 'PRIVATE_TALK',
}
